import { DatePicker as AntdDatePicker, Button } from 'antd';
import { BsCalendar2DateFill } from 'react-icons/bs';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledFooterRow = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 16px;
    border-top: 1px solid var(--color-divider);
`;

export const StyledCancelButton = styled(Button)``;

export const StyledApplyButton = styled(Button)`
    margin-left: 16px;
`;

export const StyledCalendarIcon = styled(BsCalendar2DateFill)`
    color: var(--color-neutral);
`;

export const StyledIconButton = styled.button`
    background-color: var(--color-primary);
    border-radius: 0.125rem;
    padding: 0.25rem;
`;

export const DatePickerDropdownStyles = createGlobalStyle`
  .my-range-picker-dropdown .ant-picker-presets{
    padding: 24px 16px;
    border-inline-end: 1px solid var(--color-divider);
  }

  .ant-picker-presets ul {
    padding: 0 !important;
    border-inline-end: none !important;
  }

  .ant-picker-presets ul li +li {
    margin-top: 16px !important;
  }

  .ant-picker-presets ul li  {
   padding-inline: 0px !important;
  }

  .ant-picker-presets ul li:hover {
   background-color: transparent!important; 
   color: var(--color-primary)!important;
  }

  .ant-picker-dropdown .ant-picker-header {
   margin: 16px 12px 0px 12px;
   border-radius: 2px;
   height: 35px;
   border: 1px solid var(--color-divider);
  }

  .ant-picker-dropdown .ant-picker-header .ant-picker-header-view button {
   text-align: center;
   height: 100%;
  }
  .ant-picker-dropdown .ant-picker-content td {
   min-width: 40px;
  }

  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
   border: 1px solid var(--color-divider) !important;
  }
   
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
   background: var(--color-primary) !important;
   color: var(--color-on-primary) !important;
  }

  .ant-picker-dropdown .ant-picker-header-view >button {
   color: var(--color-on-neutral) !important;
  }

  .ant-picker-dropdown .ant-picker-cell::before {
   height?: 40px;
  }

  .ant-picker-dropdown .ant-picker-cell .ant-picker-cell-inner {
   min-width: 40px;
   height: 40px;
   line-height: 40px;
   display: flex;
   justify-content: center;
   align-items: center;
   border-radius: 2px;
   color: var(--color-neutral);
  }

  .my-range-picker-dropdown 
  .ant-picker-cell-in-range::before {
  height: 40px !important;
  background-color: var(--color-primary-container) !important;
  }

 .my-range-picker-dropdown 
  .ant-picker-cell-in-range .ant-picker-cell-inner {
  height: 40px !important;
  min-width: 40px !important;
  line-height: 40px !important;
  }

 .my-range-picker-dropdown .ant-picker-cell-range-start::before,
 .my-range-picker-dropdown .ant-picker-cell-range-end::before {
  border-radius: 2px 0 0 2px !important;
  }
 .my-range-picker-dropdown 
  .ant-picker-cell-range-end::before {
  border-radius: 0 2px 2px 0 !important;
  }

  .ant-picker-date-panel .ant-picker-body {
   padding: 0px 24px;
  }
   
  .ant-picker-date-panel .ant-picker-body .ant-picker-content tbody tr td {
   padding: 2px 0px !important;
  }
}
`;

export const StyledSingleDatePicker = styled(AntdDatePicker)``;
